import { render, staticRenderFns } from "./ModalChangeCorporateEvent.vue?vue&type=template&id=34b9135c"
import script from "./ModalChangeCorporateEvent.vue?vue&type=script&lang=ts"
export * from "./ModalChangeCorporateEvent.vue?vue&type=script&lang=ts"
import style0 from "./ModalChangeCorporateEvent.vue?vue&type=style&index=0&id=34b9135c&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports